import { useQuery } from "@tanstack/react-query";
import { MaintenanceKeys } from "./maintenance.keys";
import { useApi } from "../../../api/ApiProvider";

export const useMaintenanceUtilities = () => {
  const { maintenance } = useApi();
  return useQuery({
    queryKey: MaintenanceKeys.utilities.all(),
    queryFn: () => maintenance.listMaintenanceUtilities(),
    staleTime: 10 * 60 * 1000,
    meta: { errorMessage: "Failed to load maintenance utilities" },
  });
};
